module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 portfolio-item"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_c('icon', {
    attrs: {
      "name": "star",
      "scale": "1.5"
    }
  }), _vm._v(" Featured Datasets "), _c('a', {
    staticClass: "view-all",
    attrs: {
      "target": "_blank",
      "href": "https://data.world"
    }
  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _c('carousel', {
    attrs: {
      "perPage": 4,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "perPageCustom": [
        [0, 2],
        [800, 4]
      ],
      "navigationClickTargetSize": 0,
      "navigationPrevLabel": '\uf0a8',
      "navigationNextLabel": '\uf0a9'
    }
  }, _vm._l((_vm.sorted_featured_datasets), function(fds, index) {
    return _c('slide', {}, [_c('div', {
      staticClass: "card-body"
    }, [_c('h4', {
      staticClass: "card-title"
    }, [_c('a', {
      attrs: {
        "href": fds.dataset_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fds.week))])]), _vm._v(" "), _c('p', {
      staticClass: "card-text"
    }, [_vm._v(_vm._s(fds.topic))])])])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-6 portfolio-item"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_c('icon', {
    attrs: {
      "name": "clock",
      "scale": "1.5"
    }
  }), _vm._v(" Recent Integrations"), _c('br'), _c('a', {
    staticClass: "view-all",
    attrs: {
      "target": "_blank",
      "href": "https://data.world"
    }
  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _vm._l((_vm.filtered_recent_integrations), function(fri, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": fri.URL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fri.name))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-8 col-sm-12 portfolio-item hidden-md-down"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_c('icon', {
    attrs: {
      "name": "tag",
      "scale": "1.5"
    }
  }), _vm._v(" Tag Cloud "), _c('a', {
    staticClass: "view-all",
    attrs: {
      "target": "_blank",
      "href": "https://data.world"
    }
  }, [_vm._v("[view all]")])], 1), _vm._v(" "), (_vm.tag_cloud.length > 10) ? _c('VueTagCloud', {
    attrs: {
      "data": _vm.tag_cloud
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-6 portfolio-item"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_c('icon', {
    attrs: {
      "name": "handshake",
      "scale": "1.5"
    }
  }), _vm._v(" Recent Data Partners "), _c('a', {
    staticClass: "view-all",
    attrs: {
      "target": "_blank",
      "href": "https://data.world"
    }
  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _vm._l((_vm.filtered_recent_data_partners), function(frdp, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": frdp.URL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(frdp.name))]), _vm._v(" "), _c('br'), _vm._v("(" + _vm._s(frdp.dataset_count || 0) + " datasets)")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-8 col-sm-9 portfolio-item"
  }, [_c('div', {
    staticClass: "card h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Popular")]), _vm._v(" "), _c('option', [_vm._v("New")]), _vm._v(" "), _c('option', [_vm._v("Rising")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-5 col-sm-5 bordered"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_c('icon', {
    attrs: {
      "name": "table",
      "scale": "1.5"
    }
  }), _vm._v(" Datasets "), _c('a', {
    staticClass: "view-all",
    attrs: {
      "target": "_blank",
      "href": "https://data.world"
    }
  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected === 'Popular') ? _c('div', _vm._l((_vm.filtered_datasets_popular), function(fdp, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": 'https://data.world/' + fdp.owner + '/' + fdp.datasetid,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fdp.owner))]), _vm._v(" (" + _vm._s(fdp.views) + " views)")])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected === 'New') ? _c('div', _vm._l((_vm.filtered_datasets_new), function(fdn, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": fdn.URL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fdn.name))])])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected === 'Rising') ? _c('div', _vm._l((_vm.filtered_datasets_rising), function(fdr, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": 'https://data.world/' + fdr.owner + '/' + fdr.datasetid,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fdr.owner))]), _vm._v(" (" + _vm._s(fdr.views) + " views)")])
  })) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-5 col-sm-3"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_c('icon', {
    attrs: {
      "name": "user",
      "scale": "1.5"
    }
  }), _vm._v(" Users "), _c('a', {
    staticClass: "view-all",
    attrs: {
      "target": "_blank",
      "href": "https://data.world"
    }
  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected === 'Popular') ? _c('div', _vm._l((_vm.filtered_users_popular), function(fup, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": 'https://data.world/' + fup.following,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fup.following))]), _vm._v(" (" + _vm._s(fup.count) + " following)")])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected === 'New') ? _c('div', _vm._l((_vm.filtered_users_new), function(fun, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": 'https://data.world/' + fun.agentid,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fun.displayname))])])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected === 'Rising') ? _c('div', _vm._l((_vm.filtered_users_rising), function(fur, index) {
    return _c('p', {
      staticClass: "card-text"
    }, [_c('a', {
      attrs: {
        "href": 'https://data.world/' + fur.following,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fur.following))]), _vm._v(" (" + _vm._s(fur.count) + " following)")])
  })) : _vm._e()])], 1)])])])])]), _vm._v(" "), _c('p', {
    staticClass: "version"
  }, [_vm._v("Version 0.0.29, 101618|20.51.10")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15ff7020!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dwhome.vue
// module id = 231
// module chunks = 2